import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeOrganisationType } from "../Entity/TreeNodeOrganisationType";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeOrganisationList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Organisations ({param})');
      this.parent = parent;
      this.labelNodeName = 'Organisations';
      this.expanded = true;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let nodeCreated = new TreeNodeOrganisationType(this.ioc!, this);
      nodeCreated.data.model.type_Org = params.nodeType;
      nodeCreated.labelNodeName = this.ioc!.get(LookupGetService).retrieveValueFromCache('typeorg',nodeCreated.data.model.type_Org);
      if ((params.operationType===1) && (this.ioc!.get(Art57Section).isCreateAndSendProductSection() || this.ioc!.get(Art57Section).isMedicinalProductSection())) {
        nodeCreated.data.model.localnumber = this.ioc!.get(LookupGetService).getLocalNumber();
      }
      nodeCreated.refreshLabel();
  
      this.children?.push(nodeCreated);
      this.refreshLabel();
      return [nodeCreated];
    }
  
    override getMessage(): any {
      let organisations: any[] = [];
      this.children?.forEach((node) => {
        let organisation = node as TreeNodeOrganisationType;
        let art57Message = organisation.getMessage();
        if (art57Message != null) {
          organisations.push(art57Message);
        }
      });
  
      if (this.children!.length > 0) {
        return { organisations: { organisation: organisations } };
      } else {
        return;
      }
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Operation Type', 'Type', 'Organisation Name'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeOrganisationList = new TreeNodeOrganisationList(
        this.ioc!,
        newParent
      );
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }